var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "meetingsModal",
    attrs: {
      "modal-dialog-size": "md",
      "footer-close-button-text": _vm.$t("global.words.cancel"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "d-flex flex-row align-items-center" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("dashboard.calendar.whichEmailToAddEvent")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return _vm._l(_vm.syncedEmails, function (email) {
            return _c(
              "a",
              {
                key: "email-" + email.email,
                staticClass: "dropdown-item clickable py-2 px-4",
                on: {
                  click: function ($event) {
                    return _vm.handleSelect(email)
                  },
                },
              },
              [_vm._v(_vm._s(email.email))]
            )
          })
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }